import {FooterNav} from './FooterNav';
import {FooterSocial} from './FooterSocial';
import {Stack, Box, Divider, useTheme} from '@mui/material';

const PageFooterNav = () => {
  const theme = useTheme();
  return (
    <>
      <Stack
        alignItems={'right'}
        justifyContent={'center'}
        spacing={2}
        direction={'column'}
        px={2}
        divider={
          <Divider orientation='horizontal' sx={{backgroundColor: theme.palette.grey[600], px: 2, height: '1.5px'}} />
        }
      >
        <Box>
          <FooterSocial />
        </Box>
        <Box>
          <FooterNav />
        </Box>
      </Stack>
    </>
  );
};

export default PageFooterNav;
